import React from 'react';
import { CirclePicker } from 'react-color';
import { EditBtn, RefreshColorsBtn, CloseBtn } from 'components/lib/buttons/IconButtons';
import { OT_COLORS, getRandomBrightColor } from 'utils/colorUtils';
import styles from 'styles/components/lib/icons/colorTag.css';

const N_COLORS = 15;

export default class ColorTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usedColors: props.usedColors,
      currentColor: props.color,
      colors: [],
      showPicker: false
    };
    this.togglePicker = this.togglePicker.bind(this)
  }

  componentWillMount() {
    if (!this.props.colors) this.getColors();

    window.addEventListener('closeEdit', () => {
      if(this.state.showPicker) {
        this.togglePicker();
      }
    })
  }

  componentWillReceiveProps(nProps) {
    if (!nProps.isExpanded && this.state.showPicker) this.togglePicker();

    if (nProps.usedColors &&
        nProps.usedColors.length > this.props.usedColors.length) {

      this.setState({
        usedColors: nProps.usedColors
      }, () => {
        this.getColors()
      });
    }
  }

  getColors = () => {
    let n = N_COLORS;
    let colors = Object.values(OT_COLORS);
    let { usedColors } = this.state;
    if ( colors.length > 0 ) n -= colors.length;

    if(usedColors) {
      for ( let i = 0; i < n; i++) {
        let color = getRandomBrightColor();
        if ( color === '#ffffff' || colors.indexOf(color) > -1 || usedColors.indexOf(color) > -1 ) i--;
        else colors.push(color);
      }
    }
    this.setState({ colors });
  };

  togglePicker() {
    this.setState({showPicker: !this.state.showPicker})
  }

  handleChange = (color) => { console.log('COLOR', color);
    this.props.onChange('color', color.hex);
    this.togglePicker();
  };

  handleHover = (color, e) => { console.log("ONHOVER")
  };

  render() {
    let { showPicker, colors } = this.state;
    let { color, size, isEditing } = this.props;
    let w = showPicker ? `${size.width/3.5}px` : '0px';
    return (
      <div className={styles.colorTagContainer} >
        <div className={styles.colorTag}
          onClick={isEditing ? this.togglePicker : null}
          style={{
            width: `${isEditing ? `30` : `6`}px`,
            backgroundColor: `#${color}`,
            border: `1px solid #${color}`,
            cursor: isEditing ? 'pointer' : 'initial'
          }}>
          <EditBtn
            className={styles.button}
            iconSize={20}
            style={{
              fill: '#fff',
              left: `${(isEditing) ? `-2px` : `-300vh`}`,
              opacity: `${(isEditing) ? `1` : `0`}` }} />
        </div>
          <div className={styles.picker}
            style={{
              width: `${w}`,
              padding: `${showPicker ? '20': '0'}px`,
              opacity: `${showPicker ? `1` : `0`}` }} >

            { showPicker &&
              <div style={{marginBottom: '10px', position: 'relative'}}>
                <h4 style={{marginBottom: '10px'}}>Pick Tag Color</h4>
                <RefreshColorsBtn onClick={this.getColors} color="#888888" />
                <CloseBtn onClick={this.togglePicker} style={{position: 'absolute', right: '0', top: '0'}}/>
              </div>
            }
            <CirclePicker
              width={220}
              colors={colors}
              onChangeComplete={this.handleChange}
              onSwatchOver={this.handleHover} />
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/lib/icons/ColorTag.js